import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_USERS = "fetchAdminUsers";
export const FETCH_ADMIN_USER = "fetchAdminUser";
export const STORE_ADMIN_USER = "storeAdminUser";
export const UPDATE_ADMIN_USER = "updateAdminUser";
export const DESTROY_ADMIN_USER = "destroyAdminUser";
export const FETCH_ADMIN_COMPANIES = "fetchAdminCompanies";
export const FETCH_ADMIN_COMPANY = "fetchAdminCompany";
export const UPDATE_PASSWORD_USER_ADMIN = "updatePasswordUser";
export const FETCH_ADMIN_MOST_VALUABLE_USERS = "fetchAdminMostValuableUsers";
export const BAN_USER_ADMIN = "banUserAdmin";
export const UNBAN_USER_ADMIN = "unbanUserAdmin";
export const FETCH_ADMIN_BANNED_USERS = "fetchAdminBannedUsers";
export const FETCH_ADMIN_USER_PRICES = "fetchAdminUserPrices";
export const STORE_ADMIN_USER_PRICES = "storeAdminUserPrices";

// mutation types
export const SET_ADMIN_USERS = "setAdminUsers";
export const SET_ADMIN_USERS_PAGINATION = "setAdminUsersPagination";
export const SET_ADMIN_USERS_PAGINATION_PAGE = "setAdminUsersPaginationPage";
export const SET_ADMIN_USERS_SORT = "setAdminUsersSort";
export const SET_ADMIN_USER = "setAdminUser";
export const SET_ADMIN_COMPANIES = "setAdminCompanies";
export const SET_ADMIN_COMPANY = "setAdminCompany";
export const SET_ADMIN_BANNED_USERS = "setAdminBannedUsers";
export const SET_ADMIN_BANNED_USERS_PAGINATION = "setAdminUsersPagination";
export const SET_ADMIN_USER_PRICES = "setAdminUserPrices";

const state = {
  adminUsers: [],
  adminUsersPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  sort: {
    col: "id",
    dir: "desc"
  },
  adminUser: {},
  adminCompanies: [],
  adminCompany: [],
  adminBannedUsers: [],
  adminUserPrices: [],
  adminBannedUsersPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  }
};

const getters = {
  adminUsers(state) {
    return state.adminUsers;
  },
  adminUsersPagination(state) {
    return state.adminUsersPagination;
  },
  adminUser(state) {
    return state.adminUser;
  },
  adminCompanies(state) {
    return state.adminCompanies;
  },
  adminCompany(state) {
    return state.adminCompany;
  },
  adminBannedUsers(state) {
    return state.adminBannedUsers;
  },
  adminBannedUsersPagination(state) {
    return state.adminBannedUsersPagination;
  },
  adminUserPrices(state) {
    return state.adminUserPrices;
  }
};

const actions = {
  [FETCH_ADMIN_USERS](context, payload) {
    let params = {
      page: context.state.adminUsersPagination.currentPage,
      company: payload.company,
      name: payload.name
    };

    if (payload.sort && payload.sort.col !== undefined) {
      params.sort = payload.sort;
    } else {
      params.sort = context.state.sort;
    }

    if (typeof payload.cellphone == "string") {
      params.cellphone = payload.cellphone.replace(/^09/, "+989");
    }

    return new Promise((resolve, reject) => {
      ApiService.query("admin/users", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_USERS, data.data);
          context.commit(SET_ADMIN_USERS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          if (payload.sort && payload.sort.col !== undefined) {
            context.commit(SET_ADMIN_USERS_SORT, payload.sort);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_ADMIN_MOST_VALUABLE_USERS](context) {
    return new Promise((resolve, reject) => {
      ApiService.query("admin/most-valuable-users", {
        params: {
          page: context.state.adminUsersPagination.currentPage
        }
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_USERS, data);
          context.commit(SET_ADMIN_USERS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_ADMIN_COMPANIES](context) {
    return new Promise((resolve, reject) => {
      ApiService.query("admin/companies", {
        params: {
          page: context.state.adminUsersPagination.currentPage
        }
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_COMPANIES, data.data);
          context.commit(SET_ADMIN_USERS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_ADMIN_COMPANY](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query(`admin/companies/${id}`, {})
        .then(({ data }) => {
          context.commit(SET_ADMIN_COMPANY, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_ADMIN_USER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query("profile", {
        params: {
          user: id
        }
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_USER, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },

  [STORE_ADMIN_USER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("admin/users", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_ADMIN_USER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put("profile", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_ADMIN_USER](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`admin/users/${id}`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  [UPDATE_PASSWORD_USER_ADMIN](context, payload) {
    let userId = payload[0];
    payload = payload[1];
    return ApiService.patch(`/admin/users/${userId}/password`, payload).then(
      ({ data }) => {
        return data;
      }
    );
  },
  [BAN_USER_ADMIN](context, payload) {
    let userId = payload[0];
    payload = payload[1];
    return ApiService.patch(`/admin/users/${userId}/ban`, payload).then(
      ({ data }) => {
        return data;
      }
    );
  },
  [UNBAN_USER_ADMIN](context, userId) {
    return ApiService.patch(`/admin/users/${userId}/unban`).then(({ data }) => {
      return data;
    });
  },
  [FETCH_ADMIN_BANNED_USERS](context, payload) {
    let params = {
      page: context.state.adminUsersPagination.currentPage
    };

    return new Promise((resolve, reject) => {
      ApiService.query("admin/banned-users", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_BANNED_USERS, data.data);
          context.commit(SET_ADMIN_BANNED_USERS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          if (payload.sort && payload.sort.col !== undefined) {
            context.commit(SET_ADMIN_USERS_SORT, payload.sort);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_ADMIN_USER_PRICES](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query(`admin/users/${id}/prices`, {})
        .then(({ data }) => {
          context.commit(SET_ADMIN_USER_PRICES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_ADMIN_USER_PRICES](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`admin/users/${payload.id}/prices`, payload.form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_ADMIN_USERS](state, adminUsers) {
    state.adminUsers = adminUsers;
  },
  [SET_ADMIN_USERS_PAGINATION](state, data) {
    state.adminUsersPagination = data;
  },
  [SET_ADMIN_USERS_PAGINATION_PAGE](state, page) {
    state.adminUsersPagination.currentPage = page;
  },
  [SET_ADMIN_USERS_SORT](state, payload) {
    state.sort = payload;
  },
  [SET_ADMIN_USER](state, adminUser) {
    state.adminUser = adminUser;
  },
  [SET_ADMIN_COMPANIES](state, adminCompanies) {
    state.adminCompanies = adminCompanies;
  },
  [SET_ADMIN_COMPANY](state, adminCompany) {
    state.adminCompany = adminCompany;
  },
  [SET_ADMIN_BANNED_USERS](state, adminBannedUsers) {
    state.adminBannedUsers = adminBannedUsers;
  },
  [SET_ADMIN_USERS_PAGINATION_PAGE](state, page) {
    state.adminBannedUsersPagination.currentPage = page;
  },
  [SET_ADMIN_USER_PRICES](state, adminUserPrices) {
    state.adminUserPrices = adminUserPrices;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
